import React from 'react';
import PubSub from 'pubsub-js'

import {
    Drawer,
    TextField,
    IconButton,
    FormControlLabel,
    Checkbox,
    Tooltip,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core/';

import RefreshIcon from '@material-ui/icons/Refresh';
import WarningIcon from '@material-ui/icons/Warning';
import ValidIcon from '@material-ui/icons/CheckCircle';

import ModelTypeView from './ModelTypeView';
import EnhancedTable from "@apricityhealth/web-common-lib/components/EnhancedTable";
import Plan from '@apricityhealth/web-common-lib/components/Plan';

import {
    toBoolean,
    Logger,
} from '@apricityhealth/web-common-lib';

import EditableNote from '../components/EditableNote'

const MODEL_CATEGORIES = require('../data/ModelCategories.json');
const log = new Logger();

function testFilter(filter, model) {
    if (model) {
        filter = filter.toLowerCase();
        if (model.name && model.name.toLowerCase().indexOf(filter) >= 0)
            return true;
        if (model.description && model.description.toLowerCase().indexOf(filter) >= 0)
            return true;
        if (model.modelId && model.modelId.toLowerCase().indexOf(filter) >= 0)
            return true;
        if (model.dataId && model.dataId.toLowerCase().indexOf(filter) >= 0)
            return true;

        function testSymptoms(symptoms, filter) {
            if (Array.isArray(symptoms)) {
                for (let i = 0; i < symptoms.length; ++i) {
                    let symptom = symptoms[i];
                    if (symptom.dataId && symptom.dataId.toLowerCase().indexOf(filter) >= 0)
                        return true;
                }
            }
            return false;
        }

        if (testSymptoms(model.triggerSymptoms, filter))
            return true;
        if (testSymptoms(model.primarySymptoms, filter))
            return true;
        if (testSymptoms(model.associatedSymptoms, filter))
            return true;
        if (testSymptoms(model.clinicalModifiers, filter))
            return true;
        if (testSymptoms(model.laboratory, filter))
            return true;
        if (testSymptoms(model.negativeSymptoms, filter))
            return true;
    }
    return false;
}

export class ModelTypesView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            category: props.category || localStorage.getItem("ModelTypesView.category") || '',
            dependencies: JSON.parse(localStorage.getItem("ModelTypesView.dependencies") || 'true'),
            filter: '',
            types: [],
            agent: {
                source: '',
                subject: ''
            },
            progress: null
        }
    }

    componentDidMount() {
        this.token = PubSub.subscribe('STORE_UPDATE', this.loadContent.bind(this));
        this.loadContent();
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.token);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.category !== this.props.category) {
            this.setState({ category: this.props.category || ''}, this.loadContent.bind(this));
        } else if (this.props.appContext.state.plan) {
            this.handleOpen();
        }
    }

    loadContent() {
        log.info("loadContent()");
        const { appContext: { state: { plan }, stores: { DataTypesStore } } } = this.props;
        const { dependencies, category } = this.state;

        const types = DataTypesStore.getModels().filter((e) => (!category || e.category === category) && (dependencies || (plan && e.planId === plan.planId)));
        this.setState({ types }, this.onContentLoaded.bind(this));
    }

    onContentLoaded() {
        this.updateFilter();
        this.handleOpen();
    }

    handleOpen() {
        // automatically open the question by ID if provided..
        let parts = window.location.pathname.slice(1).split('/');
        if (parts.length > 1) {
            window.history.replaceState(null, '', window.location.href.substring(0, window.location.href.lastIndexOf('/')));
            this.onOpenModel(parts[1]);
        }
    }

    updateFilter() {
        let { types, filter } = this.state;
        if (filter) {
            let filtered = [];
            for (var i = 0; i < types.length; ++i) {
                if (testFilter(filter, types[i]))
                    filtered.push(types[i]);
            }
            this.setState({ filtered });
        }
        else {
            this.setState({ filtered: null });
        }
    }

    onCloseDialog() {
        this.setState({ dialog: null });
        this.loadContent();
        if (this._types)
            this._types.setState({ selected: [] });        // unselect the question
    }

    typeSelected(s, t) {
        console.log("typeSelected:", s, t);
        const self = this;
        if (!t)
            throw new Error("t is null");
        if (s.length > 0) {
            const type = self.state.filtered ? self.state.filtered[s[0]] : self.state.types[s[0]];
            self.onOpenModel(type.modelId)
        }
        else {
            // nothing selected..
            self.setState({ progress: null, dialog: null });
        }
    }

    onOpenModel(modelId) {
        let dialog = <Drawer variant="persistent" anchor="right" open={true}>
            <ModelTypeView appContext={this.props.appContext} modelId={modelId} onClose={this.onCloseDialog.bind(this)} />
        </Drawer>;
        this.setState({ dialog });
    }

    createType() {
        console.log("createType");
        const { appContext } = this.props;
        const dialog = <Drawer variant="persistent" anchor="right" open={true} >
            <ModelTypeView appContext={appContext} modelId='' category={this.state.category} onClose={() => this.onCloseDialog()} />
        </Drawer>;
        this.setState({ progress: null, dialog: dialog });
    }



    render() {
        const { category, filtered, types, dialog, error, progress, dependencies } = this.state;
        const { appContext, appContext: { state: { plan: { planId } } } } = this.props;
        const errors = appContext.stores.DataTypesStore.getErrors(`models`).errors;
        let { filter } = this.state;

        const columnData = [
            {
                id: 'modelId', width: 25, label: 'Valid', formatValue: (v) => {
                    return errors[v] ? <Tooltip key='error' title={errors[v].join(', ')}><WarningIcon style={{ fill: 'red' }} /></Tooltip> : <ValidIcon key='valid' style={{ fill: 'green' }} />;
                }
            },
            { id: 'category', label: 'Category', formatValue: (v) => (MODEL_CATEGORIES.find((e) => e.value === v) || { label: v }).label },
            { id: 'name', numeric: false, disabledPadding: false, label: 'Name' },
            { id: 'description', numeric: false, disabledPadding: false, label: 'Description' },
            { id: 'modelId', numeric: false, disabledPadding: false, label: 'Model ID' },
            { id: 'order', numeric: true, disabledPadding: false, label: 'Order' },
            {
                id: 'planId', numeric: false, disabledPadding: false, label: 'Plan ID', formatValue: (v) => {
                    return <Plan appContext={this.props.appContext} planId={v} />
                }
            },
            { id: 'inactive', label: 'Inactive', formatValue: (v) => toBoolean(v) ? "Yes" : "No" }
        ];

        return (
            <table width='100%'><tbody>
                <tr>
                    <td>
                        <TextField style={{ margin: 5, width: 500 }} value={filter} label="Filter"
                            onChange={(e) => { filter = e.target.value; this.setState({ filter }, this.updateFilter.bind(this)); }} />
                        <FormControl style={{ margin: 5, width: 300}}>
                            <InputLabel>Category</InputLabel>
                            <Select value={category} onChange={(e) => {
                                this.setState({ category: e.target.value }, this.loadContent.bind(this));
                                localStorage.setItem("ModelTypesView.category", e.target.value);
                            }}>
                                <MenuItem value=''>All</MenuItem>
                                {MODEL_CATEGORIES.map((c) => <MenuItem key={c.value} value={c.value}>{c.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                        <FormControlLabel style={{ margin: 5 }} control={<Checkbox checked={dependencies} onChange={(e) => {
                            this.setState({ dependencies: e.target.checked }, this.loadContent.bind(this));
                            localStorage.setItem("ModelTypesView.dependencies", `${e.target.checked}`);
                        }} />} label="Show Dependencies" />
                    </td>
                    <td align="right">
                        {error}
                        <EditableNote appContext={appContext} textId={`modelTypesTooling`} planId={planId} />
                        <Tooltip title='Refresh Models'><IconButton disabled={progress !== null} onClick={this.loadContent.bind(this)}>{progress || <RefreshIcon />}</IconButton></Tooltip>
                    </td>
                </tr>
                <tr>
                    <td colSpan="2">
                        <EnhancedTable
                            title=''
                            disableMultiSelect={true}
                            onTable={table => this._types = table}
                            onSelected={(s, t) => this.typeSelected(s, t)}
                            onAdd={() => this.createType()}
                            orderBy='name'
                            columnData={columnData}
                            data={filtered ? filtered : types} />
                        {dialog}
                    </td>
                </tr>
            </tbody></table>
        );
    }
}

export default ModelTypesView;
